import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import HowToPlayVideo from "@/components/HowToPlayVideo";
import { myCharacter } from "@/lib/avatarConfig";

// A reset account (stats_reset_at) gets a new key, so the guide shows again.
const seenKey = (user) => `jangle.firstGameGuide.seen.${user?.id || "guest"}`
  + (user?.stats_reset_at ? `.${user.stats_reset_at}` : "");

// True when this player has never finished a game and hasn't seen (or
// skipped) the guide on this device yet.
export function shouldShowFirstGameGuide(user) {
  if (!user) return false;
  const played = (user.matches_played || 0) + (user.wins || 0) + (user.losses || 0) + (user.draws || 0);
  if (played > 0) return false;
  try { return !localStorage.getItem(seenKey(user)); } catch { return false; }
}

export function markFirstGameGuideSeen(user) {
  try { localStorage.setItem(seenKey(user), "1"); } catch { /* ignore */ }
}

// The How to play video, shown over the board before a player's first game.
export default function FirstGameGuide({ user, open, onClose }) {
  const close = () => {
    markFirstGameGuideSeen(user);
    onClose?.();
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) close(); }}>
      <DialogContent
        className="sm:max-w-3xl w-[calc(100vw-1.5rem)] bg-surface border-border p-3 sm:p-5 gap-3"
        data-testid="first-game-guide"
      >
        <DialogTitle className="font-display text-xl sm:text-2xl font-black tracking-tight pr-8">
          Welcome to <span className="text-brand">Jangle</span>
        </DialogTitle>
        <DialogDescription className="text-sm text-muted-foreground -mt-1">
          Here's how to play before your first game. You can watch it again any time under How to play.
        </DialogDescription>
        <HowToPlayVideo character={myCharacter(user)} onFinish={close} onSkip={close} />
      </DialogContent>
    </Dialog>
  );
}
